<div class="table-responsive animated fadeIn slow">
    <div>
        <h2 style="text-align: center;" class="titulo">LISTADO DE PRESTACIONES PAGADAS</h2>
    </div>

    <div>
        <button type="button" class="btn-agregar" title="AGREGAR XML" (click)="abrirAgregarXML()">
      <i class="fas fa-file-invoice-dollar"></i>  AGREGAR XML
    </button>
    </div>

    <div class="table-wrapper">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="tabla-asignaturas">
            <thead>
                <tr>
                    <th style="text-align: center;">Folio</th>
                    <th style="text-align: center;">Subtotal</th>
                    <th style="text-align: center;">Total</th>
                    <th style="text-align: center;">RFC emisor</th>
                    <th style="text-align: center;">Emisor</th>
                    <th style="text-align: center;">RFC receptor</th>
                    <th style="text-align: center;">Receptor</th>
                    <th style="text-align: center;">UUID</th>
                    <th style="text-align: center;">RFC proveedor certificado</th>
                    <th style="text-align: center;">No. certificado SAT</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let inventarios of xmllista">
                    <tr>
                        <td>{{inventarios.folio}}</td>
                        <td>{{inventarios.subtotal}}</td>
                        <td>{{inventarios.total}}</td>
                        <td>{{inventarios.rfc_emisor}}</td>
                        <td>{{inventarios.nombre_emisor}}</td>
                        <td>{{inventarios.rfc_receptor}}</td>
                        <td>{{inventarios.nombre_receptor}}</td>
                        <td>{{inventarios.uuid}}</td>
                        <td>{{inventarios.rfc_prov_certif}}</td>
                        <td>{{inventarios.no_certificado_sat}}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<!-- MODAL AGREGAR XML -->
<div class="modal fade" id="Agrexml" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">AGREGAR XML</h2>
            </div>

            <div class="modal-body-asig">
                <div class="container-asig">
                    <div class="row mt-3">
                        <div class="col col-lg-12">
                            <label for="xmlFile">Seleccionar archivo XML:</label>
                            <input type="file" id="xmlFile" (change)="onFileSelected($event)" accept=".xml" class="form-control">
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer-asig">
                <button type="button" class="btn-cancelar" (click)="cerrarAgregarXML()">Cerrar</button>
            </div>

        </div>
    </div>
</div>

<!-- MODAL PREVIEW / EDITAR XML -->
<div class="modal fade" id="previewXML" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">PREVISUALIZAR Y EDITAR XML</h2>
            </div>

            <div class="modal-body-asig">
                <form #f="ngForm">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Folio:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.folio" name="folio">
                        </div>
                        <div class="col-md-4">
                            <label>Subtotal:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.subtotal" name="subtotal">
                        </div>
                        <div class="col-md-4">
                            <label>Total:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.total" name="total">
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-6">
                            <label>RFC Emisor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.rfc_emisor" name="rfc_emisor">
                        </div>
                        <div class="col-md-6">
                            <label>Nombre Emisor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_emisor" name="nombre_emisor">
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-6">
                            <label>RFC Receptor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.rfc_receptor" name="rfc_receptor">
                        </div>
                        <div class="col-md-6">
                            <label>Nombre Receptor:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.nombre_receptor" name="nombre_receptor">
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-6">
                            <label>UUID:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.uuid" name="uuid">
                        </div>
                        <div class="col-md-6">
                            <label>No. Certificado SAT:</label>
                            <input class="form-control" [(ngModel)]="xmlPreview.no_certificado_sat" name="no_certificado_sat">
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer-asig">
                <button class="btn-guardar" (click)="confirmarXML()">Confirmar y Guardar</button>
                <button class="btn-cancelar" (click)="cerrarPreviewXML()">Cancelar</button>
            </div>

        </div>
    </div>
</div>